const DEVICE_CONFIG = {
  iphone: {
    label: 'iPhone',
    icon: 'bi-phone',
    width: 1320,
    height: 2868,
  },
  ipad: {
    label: 'iPad',
    icon: 'bi-tablet',
    width: 2064,
    height: 2752,
  },
  android: {
    label: 'Android',
    icon: 'bi-android2',
    width: 1290,
    height: 2796,
  },
};

module.exports = DEVICE_CONFIG;
